import { render } from "./App.vue?vue&type=template&id=a0cfdc40&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=a0cfdc40&lang=postcss"
import "./App.vue?vue&type=style&index=1&id=a0cfdc40&lang=postcss&scoped=true"
import "./App.vue?vue&type=style&index=2&id=a0cfdc40&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0cfdc40"]])

export default __exports__